var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tel-order"},[_c('el-button',{staticClass:"btn",attrs:{"size":"small","type":"success"},on:{"click":function($event){return _vm.open()}}},[_vm._v("电话下单")]),_c('tel-order-modal',{ref:"modal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }